import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

const MEDIA_BASE = `${process.env.PUBLIC_URL}/media`;
export const BACKGROUND_VIDEO = `${MEDIA_BASE}/v1.mp4?v=4`;
export const BACKGROUND_POSTER = `${MEDIA_BASE}/fw-poster.jpg?v=1080w`;
export const FALLBACK_BACKGROUND = 'linear-gradient(135deg, #0b1a2b 0%, #123252 50%, #1c4c6e 100%)';

/**
 * Poster paints immediately; video src attaches after first paint so the
 * login UI is not competing with a multi‑MB download on initial load.
 * @param {'contain'|'cover'} [fit='contain'] — object-fit for the video plane
 */
const LoginBackgroundVideo = ({ onAvailabilityChange, fit = 'contain' }) => {
  const [videoAvailable, setVideoAvailable] = useState(true);
  const [videoSrc, setVideoSrc] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let idleId;
    let timeoutId;

    const attachSrc = () => {
      if (!cancelled) setVideoSrc(BACKGROUND_VIDEO);
    };

    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
      idleId = window.requestIdleCallback(attachSrc, { timeout: 400 });
    } else {
      timeoutId = window.setTimeout(attachSrc, 0);
    }

    return () => {
      cancelled = true;
      if (idleId != null && typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(idleId);
      }
      if (timeoutId != null) window.clearTimeout(timeoutId);
    };
  }, []);

  const handleError = () => {
    setVideoAvailable(false);
    onAvailabilityChange?.(false);
  };

  if (!videoAvailable) return null;

  return (
    <Box
      component="video"
      autoPlay
      loop
      muted
      playsInline
      preload="metadata"
      poster={BACKGROUND_POSTER}
      {...(videoSrc ? { src: videoSrc } : {})}
      onError={handleError}
      sx={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: fit,
        objectPosition: fit === 'cover' ? 'center center' : 'left center',
        backgroundColor: '#000',
        // Keep the video decorative only; UI above must stay clickable.
        pointerEvents: 'none'
      }}
    />
  );
};

export default LoginBackgroundVideo;
